import React from 'react'
import AddWhiteFilledSVG from "../../../assets/icons/add-icon-white-filled.svg"
export const AddWhiteFilled: React.FC = () => {
  return (
    <img src={AddWhiteFilledSVG} alt="" className="w-[24px] h-[24px] cursor-pointer" />
  )
}
